import { appSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = []

export default function appSlice(state = initialState, action) {
    switch (action.type) {
        case appSliceDispatch.setActiveTabIndex: {
            return {
                ...state,
                activeTabIndex: action.payload
            }
        }
        default:
            return state
    }
}
